import { useRoutes } from 'react-router-dom'
import Auth from './Auth'
import Dashboard from './Dashboard'
import Groups from './Groups'
import Icons from './Icons'
import Students from './Students'
import Teachers from './Teachers'
const Pages = () => {
	const routes = useRoutes([
		// icons
		...Icons,
		// auth
		...Auth,
		// dashboard
		...Dashboard,
		// groups
		...Groups,
		// teachers
		...Teachers,
		// students
		...Students,
	])
	return routes
}
export default Pages
